import styled, { css } from 'styled-components'
import { Flex } from 'reflexbox/styled-components'

const GapFlex = styled(Flex)`
  ${({ gap }) => css`
    gap: ${gap};
  `}
`

export default GapFlex
